import { createFileRoute } from '@tanstack/react-router';

import { SearchClubProfileInfo } from '@/features/work/pages/search-club-profile-info/SearchClubProfileInfo';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/artist/$id/profile-info/$clubId/')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: SearchClubProfileInfo
});
